var WEBSITEGUID;
var LANGUAGEGUID;
function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
$(document).ready(function () {

    var url = window.location.href;
    if (url.indexOf("/Details") != -1) {
        WEBSITEGUID = websiteguid;
        LANGUAGEGUID = languageuid;
        if (getUrlVars()["CampaignId"] && getUrlVars()["EmailId"]) {
            var campaignid = getUrlVars()["CampaignId"];
            var emailid = getUrlVars()["EmailId"];

            // console.log(campaignid);
            if (typeof (Storage) !== "undefined") {
                sessionStorage.setItem("CampaignId", campaignid);
                sessionStorage.setItem("EmailId", emailid);
            } else {
                // Sorry! No Web Storage support..
            }
        }
    }
    if (url.indexOf("Catalog/ViewFLIP/") != -1) {
        WEBSITEGUID = $("#hdnWebsiteGuid").val();
        LANGUAGEGUID = $("#hdnLanguageGuid").val();

        var campaignid;
        var emailid;
        if (getUrlVars()["CampaignId"] && getUrlVars()["EmailId"]) {
            campaignid = getUrlVars()["CampaignId"];
            emailid = getUrlVars()["EmailId"];

            // console.log(campaignid);
            if (typeof (Storage) !== "undefined") {
                sessionStorage.setItem("CampaignId", campaignid);
                sessionStorage.setItem("EmailId", emailid);
            } else {
                // Sorry! No Web Storage support..
            }
            $(".bb-item").each(function (index, element) {
                var link = $(this).find(".ProductCode").children("a").attr("data-href");
                $(this).find(".ProductCode").children("a").attr("data-href", link + "?CampaignId=" + campaignid + "&EmailId=" + emailid);
            })
        }
    }

})
function SaveCampaignAnalytics(eventName, eventInfo) {

    //if (JSON.stringify(sessionStorage.CampaignId) !== '"undefined"'
    //    && JSON.stringify(sessionStorage.EmailId) !== '"undefined"')
    if (sessionStorage.CampaignId !== undefined
        && sessionStorage.EmailId !== undefined) {
        if (eventName == "Request Quote Done") {
            Event = {
                UserGuid: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["UserGuid"],
                LoginEmailId: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["EmailAddress"],
                CampaignEmailId: sessionStorage.EmailId,
                CampaignGuid: sessionStorage.CampaignId,
                EventName: eventName,
                RequestQuoteInfo: eventInfo,
            };
        }
        else if (eventName == "Order Sample Done") {
            Event = {
                UserGuid: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["UserGuid"],
                LoginEmailId: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["EmailAddress"],
                CampaignEmailId: sessionStorage.EmailId,
                CampaignGuid: sessionStorage.CampaignId,
                EventName: eventName,
                OrderSampleInfo: eventInfo,
            };
        }
        else if (eventName == "Add to Cart Click") {
            Event = {
                UserGuid: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["UserGuid"],
                LoginEmailId: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["EmailAddress"],
                CampaignEmailId: sessionStorage.EmailId,
                CampaignGuid: sessionStorage.CampaignId,
                EventName: eventName,
                AddToCartInfo: eventInfo,
            };
        }
        else if (eventName == "Email Done") {
            Event = {
                UserGuid: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["UserGuid"],
                LoginEmailId: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["EmailAddress"],
                CampaignEmailId: sessionStorage.EmailId,
                CampaignGuid: sessionStorage.CampaignId,
                EventName: eventName,
                EmailInfo: eventInfo,
            };
        }
        else if (eventName == "Order Done") {
            Event = {
                UserGuid: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["UserGuid"],
                LoginEmailId: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["EmailAddress"],
                CampaignEmailId: sessionStorage.EmailId,
                CampaignGuid: sessionStorage.CampaignId,
                EventName: eventName,
                OrderInfo: eventInfo,
            };
        }
        else {
            Event = {
                UserGuid: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["UserGuid"],
                LoginEmailId: (cookiedetails == null) ? null : JSON.parse(cookiedetails)["EmailAddress"],
                CampaignEmailId: sessionStorage.EmailId,
                CampaignGuid: sessionStorage.CampaignId,
                EventName: eventName,
                EventInfo: eventInfo,
            };
        }

        var url = SaaS_Analytics_Microservice_URL + "api/CampaignAnalytics";
        var objAjax = {};
        objAjax.url = url;
        objAjax.type = 'POST';
        objAjax.data = JSON.stringify(Event);
        objAjax.headers = { Accept: "text/html", "WebSiteGuid": WEBSITEGUID, "LanguageGuid": LANGUAGEGUID, "CookieDetails": cookiedetails };
        objAjax.OnSuccess = function (data) {

        };
        objAjax.statusCode = {

        };
        objAjax.OnError = function (msg) {
        };
        objAjax.isAsync = true;
        objAjax.MicroserviceName = 'SaaS_Analytics_Microservice';
        objAjax.contentType = 'application/json;charset=utf-8';
        callApi(objAjax);
    }
}
